import React, { useState , useEffect } from "react";

import Logo from "../assets/logo.png";
import { useParams } from "react-router-dom";
import axios from "axios";

function OTPPage({
  reSendOTP,
  verifyToken,
  error,
  phone,
  email,
  submitting,
  submittingResend,
  setSubmitting
}) {
  const [ token, setToken ] = useState("");
  
  
  const API_URLAUTOSAVE = process.env.REACT_APP_BaseApi_URLAutosave

  const phoneEmail =
    phone != null && phone != "" && email != null && email != ""
      ? phone + " and " + email
      : phone != null && phone != ""
      ? phone
      : email != null && email != ""
      ? email
      : "";
 

  // useEffect(() => {
  //   if(id){
  //     const sendotp2 = async () =>{
  //       try{
  //         const response = await axios.post( API_URLAUTOSAVE + "/account/auto-save/send_otp" ,
  //          {
  //             new_cust_id : id
  //          }
  //         )
  //         console.log(response)
  //         console.log(response?.data?.userCode)
  //         if(response?.data?.code === "00"){
  //           setUserCode(response?.data?.userCode)
  //         //   setShowOTP(true);
  //     }
  //   }catch(err){
  
  //     console.log(err)
  
  //   }
  //     }
  
  //     sendotp2()


  //   }
  
   
  // }, [id]);



  // const getAllDetails = async () =>{
  //   if (token === null || token == "") {
  //       setOTPError("Token is empty");
  //       return;
  //     }
  
  //     setSubmitting(true);
  //    const data = {
  //       new_cust_id: id,
  //       token: token, 
  //       usercode: userCode
  
  //     }
  //     console.log(data)
  //     try {
  //       const response = await axios.post(
  //           API_URLAUTOSAVE + "/account/auto-save/get_all",
  //         // "https://providusonline.providusbank.com:8443/api/account/otp/verifyToken",
  //         data
        
  //       );
  //       console.log(response.data.data)
        
  //        if (response.data.code == "00") {
  //         sessionStorage.setItem('saveData', JSON.stringify({...response.data.data}))
  //           go("basicInfo")
  //           next()  
  //        }
      
  //       // if (resp.code == "00") {
  //       //   if (true) {
       
  //       //   if (updateInfo) {
  //       //     console.log("go(updateInfo);");
  //       //     go("updateInfo");
  //       //   } else {
  //       //     next();
  //       //   }
  //       // }
  //         // if(bottomRef.current!=null){
  
  //         //}
  //       // } else {
  //       //    setOTPError(resp.message && "OTP verification failed, kindly retry.");
  //       // }
  //     } catch (er) {
  //       setOTPError("OTP verification failed, kindly retry.");
  //     }finally{
  //       setSubmitting(false)
  //     }
  //   //   setOTPSubmitting(false);
  //     // return response.data;


  // }
  // const handleSendToken = () => {
  //   if(id){
  //     getAllDetails()

  //   }else{

  //     verifyToken(token)
  //   }
  // }

  return (
    <div>
      <div className="">
        <div className="auth-wrapper">
          <div className="form-box">
            <div className="">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <img src={Logo} alt="Providus Bank" width="80" />
                <h5 className="my-3 text-warning">Verify OTP</h5>
              </div>
              <div className="row">
                <div className="col-md-4 offset-md-4 offset-sm-1 col-sm-10">
                  <div className="form-cont">
                    <form className="form-signin">
                      <p className="text-heavy mb-3 text-center">
                        <b>Enter OTP sent to {phoneEmail}</b>
                      </p>

                      <small className="text-danger text-center mb-3">
                        {error}
                      </small>

                      <div className="form-group mb-3">
                        <label htmlFor="username" className="text-warning">
                          Token
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="OTP"
                          name="token"
                          value={token}
                          required={true}
                          onChange={(e) => setToken(e.currentTarget.value)}
                        />
                      </div>
                      <div className="row">
                        <div className="col-md-5 col-sm-10 mx-auto">
                          {!submitting ? (
                            <button 
                              type = "submit"
                              className="btn btn-block submit-btn my-3 mx-auto"
                              onClick={() => verifyToken(token)}
                              
                            >
                              Validate
                            </button>
                          ) : (
                            <button
                              className="btn btn-block submit-btn my-3"
                              disabled
                            >
                              PROCESSING...
                            </button>
                          )}
                        </div>
                        {/* <div className="col-md-5 offset-md-2 offset-sm-1 col-sm-10"> */}
                          {/* {!submittingResend ? (
                            <button
                              className="btn btn-block submit-btn my-3"
                              onClick={() => {
                                setToken("");
                                reSendOTP();
                              }}
                            >
                              Resend
                            </button>
                          ) : (
                            <button
                              className="btn btn-block submit-btn my-3"
                              disabled
                            >
                              PROCESSING...
                            </button>
                          )} */}
                        {/* </div> */}
                      </div>
                      <div
                      
                      
                      className="text-center d-flex justify-content-center"
                      >Didn't receive otp?
                      
                      <a
                      style={{ textDecoration: "none", color: "#efb331" ,cursor: "pointer"}}
                      onClick={() => {
                        setToken("");
                       reSendOTP();
                     }}
                      >Resend</a> 
                      </div>

                      <br />

                      <p>
                        {/* Dear Prospect, */}
                        <br />
                        Can't access Phone Number/Email on BVN? Kindly contact
                        our Business Concierge team on 070077684387, for update
                        of details on BVN. Thank you.
                      </p>
                      <br />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OTPPage;
